import { IBase } from "./base";
import { Locker, LockerPayload } from "./locker";

export type BoardPayload = {
  id?: string,
  serial: string,
  slave_address: number,
  model: string,
  lockers: Array<LockerPayload>,
  lockers_have_product_sensor: boolean,
  lockers_have_motorized_close: boolean
};

export class Board implements IBase {
  public serial = '';
  public slave_address = 0;
  public model = 'STANDARD';
  public lockers: Locker[] = [];
  public lockers_have_product_sensor = false;
  public lockers_have_motorized_close = false;
  public id = '';
  public puc_id = '';
  
  static payload(args: Board, isNew = false): BoardPayload {
    const payload: BoardPayload = {
      id: args.id,
      serial: args.serial,
      slave_address: args.slave_address,
      model: args.model,
      lockers: Locker.lockersPayload(args.lockers),
      lockers_have_product_sensor: args.lockers_have_product_sensor,
      lockers_have_motorized_close: args.lockers_have_motorized_close
    };
    
    if (isNew) {
      const {id: _, ...sanitized} = payload;
      return sanitized;
    }

    return payload;
  }

  static boardsPayload(args: Array<Board>, isNew = false): Array<BoardPayload> {
    const temp = [];
    for (const board of args) {
      temp.push(Board.payload(board, isNew));
    }

    return temp;
  }
}
